<template>
  <div class="payoutPreferences">
    <div class="payoutPreferences__header">
      <h1 class="payoutPreferences__header__title medium-title">
        Payout Preferences
      </h1>
      <span>Our secure payment system supports payment to your bank account, which can be setup and edited here.</span>
    </div>
    <div class="payoutPreferences__body">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td class="listview__title">BANK NAME</td>
              <td class="listview__title">BRANCH</td>
              <td class="listview__title">ACCOUNT NUMBER</td>
              <td class="listview__title">ACCOUNT NAME</td>
              <td class="edit"></td>
            </tr>
          </thead>
          <tbody>
            <tr class="content">
              <td><span>{{bankName == "" ? "Not Set" : bankName}}</span></td>
              <td><span>{{bankBranch == "" ? "Not Set" : bankBranch}}</span></td>
              <td><span>{{accountNumber  == "" ? "Not Set" : accountNumber}}</span></td>
              <td><span>{{accountName == "" ? "Not Set" : accountName}}</span></td>
              <td><button class="btn-regular secondary" @click.stop="toggleModal">Edit Detail</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <adx-modal v-if="showEditor" title="Edit Detail" @modal-close="toggleModal">
      <div slot="content" class="payoutPreferences__editor">
        <adx-input :ref="dataRef.bankName" :label="`Bank Name *`" :error.sync="bankNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:50']" :value.sync="bankName" />
        <adx-input :ref="dataRef.bankBranch" :label="`Branch *`" :error.sync="bankBranchError" :validation="['NotEmpty', 'MaxLength:50']" :value.sync="bankBranch" />
        <adx-input :ref="dataRef.accountNumber" :label="`Account Number *`" :error.sync="accountNumberError" :validation="['NotEmpty', 'Numeric', 'MaxLength:15']" :value.sync="accountNumber" />
        <adx-input :ref="dataRef.accountName" :label="`Account Name *`" :error.sync="accountNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:50']" :value.sync="accountName" />
        <div class="buttons">
          <button class="btn-block primary not-rounded" @click.stop="updatePreferences()" :disabled="loadingUpdate">
            Submit
          </button>
          <adx-loading-white v-if="loadingUpdate" class="loading-circle" />
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
import FormAbstraction from '@/components/Form'
import Input from '@/components/Form/Input'
import LoadingSpinnerWhite from '@/components/Loading/Secondary-white'

const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-payout-preferences',
  components: {
    'adx-modal': Modal,
    'adx-form': FormAbstraction,
    'adx-input': Input,
    'adx-loading-white': LoadingSpinnerWhite
  },
  props: {

  },
  data() {
    return {
      bankName: '',
      bankBranch: '',
      accountNumber: '',
      accountName: '',
      bankNameError: '',
      bankBranchError: '',
      accountNumberError: '',
      accountNameError: '',
      loadingUpdate: false,
      dataRef: {
        bankName: 'bankName',
        bankBranch: 'bankBranch',
        accountNumber: 'accountNumber',
        accountName: 'accountName',
      },
      showEditor: false,
      wrapper: {
        alertWrapper: `content`
      },
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.getPayoutPreferences()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleModal() {
      this.showEditor = !this.showEditor
    },
    getPayoutPreferences () {
      (async () => {
        const categoryName = this.selectedQuickValue
        const { data } = await api.get(apiV2.payoutPreferences, { needToken: true})
        this.bankName = data.bank_name
        this.bankBranch = data.branch
        this.accountNumber = data.account_number
        this.accountName = data.account_name
      })();
    },
    updatePreferences() {
      let validation = this.validate_preference()
      if (validation.isValid) {
        (async () => {
          this.loadingUpdate = true
          let data = {
            bank_name: this.bankName,
            branch: this.bankBranch,
            account_number: this.accountNumber,
            account_name: this.accountName,
          }
          let response = await api.put(apiV2.payoutPreferences, data, {needToken: true})
          if (response.status == 201) {
            this.loadingUpdate = false
            this.$notify({
              group: 'saved',
              title: 'Preference',
              text: 'Preference created',
              type: 'success'
            });
            this.toggleModal()
            this.getPayoutPreferences()
          } else if (response.status == 200) {
            this.loadingUpdate = false
            this.$notify({
              group: 'saved',
              title: 'Preference',
              text: 'Preference updated',
              type: 'success'
            });
            this.toggleModal()
            this.getPayoutPreferences()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'sorry something went wrong!',
              type: 'danger'
            });
          }
        })();
      } else {
        this.raiseError(validation.id)
      }
    },
    validate_preference() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in this.dataRef) {
        let value = this.$refs[key].$el.firstElementChild.value
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = this.dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = false
      let dataRef = this.dataRef
      switch(value) {
        case dataRef.bankName:
          error = this.bankNameError
          break
        case dataRef.bankBranch:
          error = this.bankBranchError
          break
        case dataRef.accountNumber:
          error = this.accountNumberError
          break
        case dataRef.accountName:
          error = this.accountNameError
          break
      }

      return error
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>